import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewStandardQuoteComponent } from './standard-quote/new-standard-quote.component';
import { AuthGuard } from '@app/common/auth.guard';
import { ListStandardQuotePageComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-standard-quote-page.component';
import { NewDealStandardQuotePageComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-page.component';

const routes: Routes = [

  {
    canActivate: [AuthGuard],
    path: 'standard-quote',
    component: ListStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote',
    component: NewStandardQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Nueva cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id',
    component: NewStandardQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },

  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote/new-deal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote/edit-deal/:idDeal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id/edit-deal/:idDeal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id/new-deal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },


];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuoteRoutingModule {}
